import React, { useState } from 'react';
import { Grid, Typography, Button, InputBase, Box } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Logo from '../assets/images/Logo.png';
import { helperText } from '../assets/theme/Theme';
import { generateResetUserPasswordLink } from '../services/UserService';

function ForgotPassword(props) {
	const params = useParams();
	const navigate = useNavigate();
	const [email, setEmail] = useState('');
	const [confirmPassword, setConfirmPassword] = useState('');
	const [emailError, setEmailError] = useState({
		status: false,
		msg: '',
	});

	function onChangeEmail(e) {
		setEmailError({ status: false, msg: '' });
		setEmail(e.target.value);
	}

	async function onResetPassword() {
		if (email && email === '') {
			setEmailError({ status: true, msg: 'Email is Required.' });
			return;
		}

		const result = await generateResetUserPasswordLink(email);

		if (result.message === 'Success') {
			localStorage.clear();
			navigate('/');
			toast.success('Rest Password link send to your email.');
		} else {
			toast.error(result.message);
		}
	}

	return (
		<div
			style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				minHeight: '100vh',
			}}>
			<Grid container justifyContent={'center'}>
				<Grid item xs={10} md={4}>
					<Grid
						container
						flexDirection={'row'}
						justifyContent={'center'}
						alignItems={'center'}>
						<Box
							component={'img'}
							src={Logo}
							sx={{
								padding: '2px',
								borderRadius: '5px',
							}}
							width={180}
							height={45}
						/>
					</Grid>
					<Grid
						item
						xs={12}
						md={12}
						style={{
							textAlign: 'left',
							border: '1px solid #F4F5F6',
							boxShadow:
								'0px 10px 110px 1px rgba(59, 59, 59, 0.08)',
							marginTop: '20px',
							paddingTop: '20px',
							padding: '15px',
							borderRadius: '10px',
							backgroundColor: '#FFF',
						}}>
						<Typography
							fontSize={'16px'}
							color={'#7C7C7C'}
							paddingBottom="10px">
							Email
						</Typography>
						<Grid
							container
							justifyContent={'space-between'}
							alignItems={'center'}
							border={
								emailError.status
									? '1px solid red'
									: '1px solid #D9D9D9'
							}
							color={'#777E90'}
							paddingX={'15px'}
							borderRadius={'5px'}>
							<InputBase
								type={'text'}
								sx={{
									padding: '4px',
									width: '90%',
									color: '#777E90',
								}}
								error={emailError.status}
								onChange={onChangeEmail}
							/>
						</Grid>
						<Typography style={helperText}>
							{emailError.msg}
						</Typography>
						<Grid container justifyContent={'center'}>
							<Button
								onClick={onResetPassword}
								style={{
									width: '100%',
									boxShadow: 'none',
									marginTop: '10px',
									textTransform: 'none',
									backgroundColor: '#28696D',
								}}
								variant="contained">
								Reset
							</Button>
							<Typography
								variant="subtitle2"
								style={{
									color: '#777E91',
									paddingTop: '10px',
									paddingBottom: '10px',
								}}>
								<a href="/" style={{ textDecoration: 'none' }}>
									<span
										style={{
											color: '#777E90',
											cursor: 'pointer',
										}}>
										Back to Login
									</span>
								</a>
							</Typography>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</div>
	);
}

export default ForgotPassword;
